var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pharmacy-card corner-round-sm box-sdw"},[_c('div',{staticClass:"amt-box-container"},_vm._l((['adult', 'child']),function(ageType){return _c('amt-box',{key:ageType,attrs:{"type":ageType,"maskAmt":{
					adult: _vm.pharmacyData.properties['mask_adult'],
					child: _vm.pharmacyData.properties['mask_child']
				}}})}),1),_c('pharmacy-info',{attrs:{"pharmacyData":_vm.pharmacyData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }